import {
  borderRadius,
  Input,
  Modal,
  typographyV2,
} from '@toggle/design-system';
import styled from 'styled-components';

export const StyledModalRoot = styled(Modal)`
  [data-modal-container] {
    width: 100%;
    max-width: 740px;
    background: var(--background-soft);
  }
`;

export const ConditionBuilderOptions = styled.section`
  padding: 20px;
`;
export const ConditionOptions = styled.section`
  display: flex;
  gap: 12px;
  background: var(--surface-default);
  padding: 12px;
  ${borderRadius.r2};
  align-items: flex-start;
`;

export const OptionLabel = styled.span`
  ${typographyV2.bodySm}
  display: inline-flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  padding: 12px 0px;
`;

export const StyledInput = styled(Input).attrs({ size: 'medium' })`
  max-width: 90px;
  ${borderRadius.r2};
  border: 1px solid var(--border-default);
  background: var(--surface-soft);
  [data-input-element] {
    width: 40px;
  }
  [data-input-wrapper] {
    background-color: unset;
    border: none;
  }
`;

export const InputSuffix = styled.span`
  color: var(--text-soft);
  ${typographyV2.bodyBase};
  padding-right: 12px;
`;

export const Root = styled.div`
  width: 100%;
  display: flex;
  gap: inherit;
  justify-content: inherit;
  align-items: inherit;
  overflow: hidden;
  min-width: 0;
`;

export const DropdownWrapper = styled.div`
  display: inline-flex;
  width: auto;
  flex-shrink: 0;
`;
